/// <reference types="vite/client" />
import * as scLegacyInitializers from '@betterment/style-closet-legacy';
import { startCacheWorker } from '@betterment/js-runtime';
import { startStimulusApplication } from '../../index';
import jQuery from 'jquery';
import Turbolinks from 'turbolinks';
import '../vendor/jquery.turbolinks';
import Rails from '@rails/ujs';

import '../vendor/jquery.readyselector';
import '../vendor/jSignature';
import '../vendor/jQuerySignaturePlugin';
import '../vendor/jQuerySpinnerPlugin';
import '../vendor/qtip';
import '../vendor/webshim.range-input';
import '../vendor/lodash';
import '../vendor/modernizr';
import '../vendor/d3';
import '../vendor/typed-jquery';
import '../scripts/behaviors';
import '../scripts/form_behaviors';
import '../scripts/pages';
import '../scripts/turbolinks_workarounds';
import '../vendor/calendly-widget';
(window as any).$ = jQuery;
(window as any).jQuery = jQuery;
window.Turbolinks = Turbolinks;

Turbolinks.start();

Object.values(scLegacyInitializers).forEach(initializer => initializer());

if (!window._rails_loaded) Rails.start();

startStimulusApplication();
startCacheWorker();
